import * as React from "react";

const TiffanyWest = () => {
  return (
    <ol className="references">
      <li>
        Centers for Disease Control and Prevention. Advancing health equity in chronic disease prevention and 
        management. Last reviewed December 8, 2022. Accessed 
        February 3, 2023. <a target="_blank" href="https://www.cdc.gov/chronicdisease/healthequity/index.htm">https://www.cdc.gov/chronicdisease/healthequity/index.htm</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. National Center for HIV, Viral Hepatitis, STD, and TB 
        Prevention. What is health equity? Last reviewed December 16, 2022. Accessed 
        February 3, 2023. <a target="_blank" href="https://www.cdc.gov/nchhstp/healthequity/index.html">https://www.cdc.gov/nchhstp/healthequity/index.html</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and African American people. Last reviewed January 10, 2023. Accessed 
        February 3, 2023. <a target="_blank" href="https://www.cdc.gov/hiv/group/racialethnic/africanamericans/index.html">https://www.cdc.gov/hiv/group/racialethnic/africanamericans/index.html</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. National Center for HIV, Viral 
        Hepatitis, STD, and TB Prevention. HIV and Black/African American people in 
        the U.S. Last reviewed July 6, 2022. Accesssed 
        February 3, 2023. <a class="d-inline d-lg-inline-block" target="_blank" href="https://www.cdc.gov/nchhstp/newsroom/fact-sheets/hiv/black-african-american-factsheet.html">https://www.cdc.gov/nchhstp/newsroom/fact-sheets/hiv/black-african-american-factsheet.html</a>
      </li>
      <li>
        US Department of Health & Human Services. Office of Minority Health. Profile: Black/African 
        Americans. Last modified October 12, 2021. Accesssed February 3, 
        2023. <a target="_blank" href="https://minorityhealth.hhs.gov/omh/browse.aspx?lvl=3&lvlid=61">https://minorityhealth.hhs.gov/omh/browse.aspx?lvl=3&lvlid=61</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and African American people. Published February 2022. Accessed 
        February 3, 2023.  <a target="_blank" href="https://www.cdc.gov/hiv/group/racialethnic/africanamericans/">https://www.cdc.gov/hiv/group/racialethnic/africanamericans/</a>
      </li>
      <li>
        Gilead Sciences, Inc., press release. Gilead announces racial equity community 
        impact fund to support black communities across United States. Published December 9, 
        2020. Accessed February 3, 2023.  <a target="_blank" href="https://www.businesswire.com/news/home/20201209005330/en/">https://www.businesswire.com/news/home/20201209005330/en/</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV in the southern United States. Published September 2019. 
        Accessed February 3, 2023. <a target="_blank" href="https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf">https://www.cdc.gov/hiv/pdf/policies/cdc-hiv-in-the-south-issue-brief.pdf</a>
      </li>
      <li>
        The White House. National HIV/AIDS Strategy for the United States 2022–2025. 2021. 
        Accessed February 3, 2023. <a class="d-inline d-lg-inline-block" target="_blank" href="https://files.hiv.gov/s3fs-public/NHAS-2022-2025.pdf">https://files.hiv.gov/s3fs-public/NHAS-2022-2025.pdf</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Health disparities in HIV, viral hepatitis, STDs, and TB: African 
        Americans/Blacks. Last reviewed September 14, 2020. Accessed 
        February 3, 2023. <a target="_blank" href="https://www.cdc.gov/nchhstp/healthdisparities/africanamericans.html">https://www.cdc.gov/nchhstp/healthdisparities/africanamericans.html</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. HIV and African American people: viral suppression and 
        barriers to care. Last reviewed January 10, 2023. Accessed 
        February 3, 2023. <a target="_blank" href="https://www.cdc.gov/hiv/group/racialethnic/africanamericans/viral-suppression.html">https://www.cdc.gov/hiv/group/racialethnic/africanamericans/viral-suppression.html</a>
      </li>
      <li>
        US Census Bureau. U.S. Census Bureau history: historically Black colleges and 
        universities (HBCUs). Published October 2022. Accessed 
        February 3, 2023.  <a target="_blank" href="https://www.census.gov/history/www/homepage_archive/2022/october_2022.html">https://www.census.gov/history/www/homepage_archive/2022/october_2022.html</a>
      </li>
      <li>
        National Museum of African-American History and Culture. Homecoming: 
        a celebration of HBCUs and their 
        legacies. Accessed February 3, 2023. <a target="_blank" href="https://nmaahc.si.edu/homecoming-celebration-hbcus-and-their-legacies">https://nmaahc.si.edu/homecoming-celebration-hbcus-and-their-legacies</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. National Center for HIV, Viral Hepatitis, STD, and TB 
        Prevention. Press release. Lifetime risk of HIV diagnosis. Published February 23, 
        2016. Accessed February 3, 2023. <a target="_blank" href=" https://www.cdc.gov/nchhstp/newsroom/2016/croi-press-release-risk.html"> https://www.cdc.gov/nchhstp/newsroom/2016/croi-press-release-risk.html</a>
      </li>
      <li>
        HIV.gov. White House’s Harold Phillips discusses 2023 priorities. Published 
        January 20, 2023. Accessed February 3, 2023. <a target="_blank" href="https://www.hiv.gov/blog/white-house-s-harold-phillips-discusses-2023-priorities">https://www.hiv.gov/blog/white-house-s-harold-phillips-discusses-2023-priorities</a>
      </li>
      <li>
        Centers for Disease Control and Prevention. Explore CDC’s role in Ending the HIV Epidemic in 
        the U.S. Last reviewed June 7, 2022. Accessed February 3, 
        2023. <a target="_blank" href="https://www.cdc.gov/endhiv/index.html">https://www.cdc.gov/endhiv/index.html</a>
      </li>
      <li>
        US Department of Health & Human Services. Office of Disease Prevention and Health Promotion. Access to health 
        services. Accessed February 3, 2023.  <a target="_blank" href="https://health.gov/healthypeople/priority-areas/social-determinants-health/literature-summaries/access-health-services ">https://health.gov/healthypeople/priority-areas/social-determinants-health/literature-summaries/access-health-services </a>
      </li>
      <li>
        Dawson L. People with HIV in non-Medicaid expansion states: who could gain coverage eligibility through Build 
        Back Better or future expansion? Kaiser Family Foundation. Published 
        February 15, 2022. Accessed February 3, 2023.  <a class="d-inline d-lg-inline-block" target="_blank" href="https://www.kff.org/hivaids/issue-brief/people-with-hiv-in-non-medicaid-expansion-states-who-could-gain-coverage-eligibility-through-build-back-better-or-future-expansion/">https://www.kff.org/hivaids/issue-brief/people-with-hiv-in-non-medicaid-expansion-states-who-could-gain-coverage-eligibility-through-build-back-better-or-future-expansion/</a>
      </li>
      <li>
        Office of the Assistant Secretary for Planning and Evaluation. Health insurance coverage 
        and access to care among Black Americans: recent trends and key challenges. Published February 22, 
        2022. Accessed February 3, 2023.   <a class="d-inline d-lg-inline-block" target="_blank" href="https://aspe.hhs.gov/reports/health-insurance-coverage-access-care-among-black-americans">https://aspe.hhs.gov/reports/health-insurance-coverage-access-care-among-black-americans</a>
      </li>
      <li>
        World Population Review. Abstinence-only education states. Accessed February 3, 
        2023. <a class="d-inline d-lg-inline-block" target="_blank" href="https://worldpopulationreview.com/state-rankings/abstinence-only-education-states">https://worldpopulationreview.com/state-rankings/abstinence-only-education-states</a>
      </li>
      <li>
        Jozkowski KN, Crawford BL. The status of reproductive and sexual health in southern USA: policy recommendations 
        for improving health 
        outcomes. <em>Sex Res Soc Policy.</em> 2016;13(3):252-262. doi:10.1007/s13178-015-0208-7. 
      </li>
      <li>
      Heller J. Rumors and realities: making sense of HIV/AIDS conspiracy narratives and contemporary legends. <em>Am J Public Health.</em> 2015;105(1):e43-e50. doi:10.2105/AJPH.2014.302284.
      </li>
    </ol>
  )
  }

export default TiffanyWest;